import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot='input'
      className={cn(
        "file:text-foreground placeholder:text-text-muted selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-border-primmary flex h-14 w-full min-w-0 rounded-full border-[1.5px] bg-transparent px-3 py-1 text-base shadow-none transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-sm placeholder:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm lg:h-[60px] lg:placeholder:text-base xl:h-[48px] xl:placeholder:text-xs",
        "focus-visible:border-border-primmary focus-visible:ring-ring/50 focus-visible:ring-[0px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-border-destructive",
        className
      )}
      {...props}
    />
  );
}

export { Input };
